module.exports = __webpack_public_path__ + "static/media/performance-play.c9bc533b.svg";